import type { AllowedTracingUrls } from '@anchorage/datadog-rum';

/**
 * Origins kyc serves this app from. kyc also serves `/graphql/<id>` off the
 * same router, so every traced request is same-origin and the page origin is
 * what the matchers see.
 *
 * Anchorage and Porto are one deployment behind different hosts, and
 * production drops the `-<env>` suffix on both.
 *
 * The port group is required before the terminator: `host:443@evil.example`
 * parses as userinfo, so a bare `:` would let any host impersonate ours.
 */
export const ONBOARDING_TRACING_URLS: AllowedTracingUrls = [
  {
    match:
      /^https:\/\/(?:kyc|porto\.signup)\.anchorage(?:-development|-staging)?\.com(?::\d+)?(?:\/|$)/,
    propagatorTypes: ['tracecontext'],
  },
];
